import { useEffect } from "react";
import { useTrackingConfig } from "@/hooks/useTrackingConfig";
import { captureUtm, initTracking } from "@/lib/tracking";
import ConsentBanner from "@/components/ConsentBanner";

/**
 * Mounts the marketing/analytics stack once the admin-managed config loads.
 * Captures UTM attribution on entry, boots the tracking engine (Consent Mode v2
 * default-denied), and renders the GDPR consent banner.
 */
const TrackingProvider = () => {
  const { data: config } = useTrackingConfig();

  // First-touch UTM capture — independent of consent / config.
  useEffect(() => {
    captureUtm();
  }, []);

  useEffect(() => {
    if (config) initTracking(config);
  }, [config]);

  const showBanner = Boolean(config?.enabled && config?.consentBannerEnabled);
  return <ConsentBanner show={showBanner} />;
};

export default TrackingProvider;
